import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import { Link } from "react-router-dom";
import StarRating from "../Star-Component/StarRating";
import { UNPROTECTED_ROUTES } from "../../routes/routes";

const CourseCard = ({
  name,
  offer_price,
  offer_discount,
  price,
  payment_plans = [],
  course_banner,
  title_1,
  value_1,
  title_2,
  value_2,
  title_3,
  value_3,
  title_4,
  value_4,
  rating,
  faculty_name,
  thumbnail,
  description,
  totalRating,
  id,
  exploreMoreLink,
  showPrice,
  showBuyNow,
  showExploreMore,
  showView,
  dimensions = "",
}) => {
  const plans = Array.isArray(payment_plans)
    ? payment_plans.filter(Boolean)
    : [];

  const sortedPlans = [...plans].sort(
    (a, b) =>
      Number(a?.validity || 0) -
      Number(b?.validity || 0)
  );

   const plan12 = sortedPlans.find(
    (plan) => Number(plan.validity) === 12
  );
  const maxPlan =
    sortedPlans.length > 0
      ? sortedPlans.reduce((max, plan) =>
        Number(plan.validity) > Number(max.validity) ? plan : max
      )
      : null;
  const midPlan = plan12 || maxPlan;

  const hasMidPlan = Boolean(midPlan);

  const hasMidPlanDiscount =
    Number(midPlan?.offer_discount || 0) > 0;

  return (
    <Link
      to={
        exploreMoreLink +
        "/" +
        id +
        UNPROTECTED_ROUTES?.description
      }
    >
      <CardContent
        style={{ fontFamily: "DM Sans" }}
        className="aspect-square p-0 rounded-2xl shadow-xl"
      >
        <div
          className="lg:text-xl text-lg ml-5 my-2"
          style={{ fontWeight: "600" }}
        >
          {name}

          {/* Section 1 - Course Banner */}
          <div className="mt-2 mr-5">
            <div
              className={`
                relative
                overflow-hidden
                rounded-2xl
                ${dimensions}
                h-[10rem]
              `}
            >
              {course_banner ? (
                <img
                  src={course_banner}
                  alt={name}
                  className={
                    "w-full h-full object-cover rounded-2xl"
                  }
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";

                    const placeholder =
                      e.currentTarget.parentElement.querySelector(
                        ".course-card-placeholder"
                      );

                    if (placeholder) {
                      placeholder.classList.remove("hidden");
                    }
                  }}
                />
              ) : null}

              {/* Course Image Placeholder */}
              <div
                className={`
                  course-card-placeholder
                  ${course_banner ? "hidden" : ""}
                  absolute
                  inset-0
                  flex
                  flex-col
                  items-center
                  justify-center
                  rounded-2xl
                  bg-gradient-to-br
                  from-[#F3EFF6]
                  to-[#E7E1EB]
                `}
              >
                <div
                  className="
                    flex
                    h-12
                    w-12
                    items-center
                    justify-center
                    rounded-full
                    bg-white
                    shadow-sm
                  "
                >
                  <span className="text-xl font-bold text-[#5A277C]">
                    R
                  </span>
                </div>

                <span className="mt-1 px-2 text-center text-sm font-semibold text-[#5A277C]">
                  {name || "Course"}
                </span>
              </div>
            </div>
          </div>

          {/* Section 2 - Faculty img + name & star */}
          {(faculty_name || thumbnail) && (
            <div className="flex items-center gap-2 mt-2">
              {thumbnail ? (
                <img
                  src={thumbnail}
                  alt={faculty_name || "Faculty"}
                  className="w-8 h-8 rounded-full object-cover"
                  loading="lazy"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-[#F3EFF6] flex items-center justify-center">
                  <span className="text-xs font-bold text-[#5A277C]">
                    F
                  </span>
                </div>
              )}

              {faculty_name ? (
                <div className="text-sm font-medium">
                  {faculty_name}
                </div>
              ) : null}
            </div>
          )}

          {/* Rating */}
          {rating !== undefined && rating !== null && (
            <div className="flex items-center gap-2 mt-2">
              <StarRating rating={rating} />

              <span className="text-xs text-gray-500">
                ({totalRating || 0} Ratings)
              </span>
            </div>
          )}

          {/* Section 3 - Course Name */}

          {/* Section 4 - Course Description */}
          <div className="lg:text-sm text-xs my-3">
            {stripText(stripHtml(description || ""), 80)}
          </div>

          {/* Section 5 - Metrics */}
          <div className="flex justify-around border-b border-gray-200 pb-2 lg:text-sm text-[0.7rem]">
            {/* title1 */}
            {value_1 && (
              <div className="flex flex-col items-center">
                <div className="font-semibold">
                  {value_1}
                </div>
                <div className="text-[#82808D]">
                  {title_1}
                </div>
              </div>
            )}

            {/* title2 */}
            {value_2 && (
              <div className="flex flex-col items-center">
                <div className="font-semibold">
                  {value_2}
                </div>
                <div className="text-[#82808D]">
                  {title_2}
                </div>
              </div>
            )}

            {/* title3 */}
            {value_3 && (
              <div className="flex flex-col items-center">
                <div className="font-semibold">
                  {value_3}
                </div>
                <div className="text-[#82808D]">
                  {title_3}
                </div>
              </div>
            )}

            {/* title4 */}
            {value_4 && (
              <div className="flex flex-col items-center">
                <div className="font-semibold">
                  {value_4}
                </div>
                <div className="text-[#82808D]">
                  {title_4}
                </div>
              </div>
            )}
          </div>

          {/* Section 6 - Button and Price */}
          <div className="flex justify-between items-center my-[1rem]">
            {/* Price */}
            {showPrice && (
              <>
                {hasMidPlan ? (
                  <div className="flex items-center gap-1">
                    {/* Middle Plan Discount */}
                    {hasMidPlanDiscount && (
                      <div className="rounded-l-full rounded-r-full text-white bg-[#5A277C] p-1 w-10 text-xs text-center">
                        {midPlan?.offer_discount}% off
                      </div>
                    )}

                    <div className="flex flex-col">
                      {/* Original Middle Plan Price */}
                      {hasMidPlanDiscount && (
                        <div className="line-through text-gray-500 lg:text-[1rem] text-sm">
                          ₹{midPlan?.price}
                        </div>
                      )}

                      {/* Middle Plan Price */}
                      <div className="px-4 py-2 rounded-2xl bg-[#5A277C] text-white">
                        ₹
                        {hasMidPlanDiscount
                          ? midPlan?.offer_price
                          : midPlan?.price}
                      </div>
                    </div>

                    {/* Plan Validity */}
                    <div className="text-xs text-[#77747C]">
                      for {midPlan?.validity || 0} Months
                    </div>
                  </div>
                ) : null}
              </>
            )}

            {/* Buttons */}
            <div className="flex gap-3">
              {/* Explore More Button */}
              {showExploreMore && (
                <div>
                  <Link
                    to={
                      exploreMoreLink +
                      "/" +
                      id +
                      UNPROTECTED_ROUTES?.description
                    }
                  >
                    <button
                      className="text-[#03B3C3] px-2 py-1 rounded-xl cursor-pointer lg:text-[1rem] text-sm"
                      style={{
                        backgroundColor:
                          "rgba(30, 203, 219, 0.15)",
                        fontWeight: 700,
                      }}
                    >
                      Explore More
                    </button>
                  </Link>
                </div>
              )}

              {/* Buy Now Button */}
              {showBuyNow && hasMidPlan && (
                <div>
                  <Link
                    to={
                      exploreMoreLink +
                      "/" +
                      id
                    }
                  >
                    <button
                      className="text-[#5A277C] px-2 py-1 rounded-xl cursor-pointer"
                      style={{
                        backgroundColor:
                          "rgba(90, 39, 124, 0.10)",
                        fontWeight: 700,
                      }}
                    >
                      Buy Now
                    </button>
                  </Link>
                </div>
              )}

              {/* View Button */}
              {showView && (
                <div>
                  <Link
                    to={
                      exploreMoreLink +
                      "/" +
                      id +
                      UNPROTECTED_ROUTES?.description
                    }
                  >
                    <button
                      className="text-[#03B3C3] px-2 py-1 rounded-xl cursor-pointer lg:text-[1rem] text-sm"
                      style={{
                        backgroundColor:
                          "rgba(30, 203, 219, 0.15)",
                        fontWeight: 700,
                      }}
                    >
                      View
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>

          <div className="text-white text-[1px]">
            h
          </div>
        </div>
      </CardContent>
    </Link>
  );
};

export default CourseCard;